import { useEffect, useId, useRef, useState } from 'react';
import { Icon } from '../../Icon.js';
import { DAALUU_SIZE_MAX, DAALUU_SIZE_MIN, useDaaluuDisplaySize } from '../../../daaluuDisplaySize.js';

/** "Size" button beside Pause: shrink the table and tiles so the whole game fits small screens. */
export function DaaluuSizeControl({ mn }: { mn: boolean }) {
  const { size, isAuto, update, reset } = useDaaluuDisplaySize();
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const wrapper = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (event: PointerEvent | KeyboardEvent) => {
      if (event instanceof KeyboardEvent ? event.key === 'Escape' : !wrapper.current?.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener('pointerdown', close);
    document.addEventListener('keydown', close);
    return () => { document.removeEventListener('pointerdown', close); document.removeEventListener('keydown', close); };
  }, [open]);

  const slider = (key: 'table' | 'tiles', label: string) => (
    <label className="daaluu-size-row">
      <span>{label}</span>
      <input
        type="range"
        min={DAALUU_SIZE_MIN * 100}
        max={DAALUU_SIZE_MAX * 100}
        step={5}
        value={Math.round(size[key] * 100)}
        onChange={(e) => update({ [key]: Number(e.target.value) / 100 })}
      />
      <output>{Math.round(size[key] * 100)}%</output>
    </label>
  );

  return (
    <div className="daaluu-size-control" ref={wrapper}>
      <button type="button" className="icon-button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpen((o) => !o)}
        aria-label={mn ? 'Хэмжээ' : 'Size'} title={mn ? 'Ширээ ба модны хэмжээ' : 'Table and tile size'}
        data-tooltip={open ? undefined : mn ? 'Ширээ ба модны хэмжээ' : 'Table and tile size'}>
        <Icon name="scaling" size={15} />
      </button>
      {open && (
        <div className="daaluu-size-panel" id={panelId} role="group" aria-label={mn ? 'Ширээ ба модны хэмжээ' : 'Table and tile size'}>
          {slider('table', mn ? 'Ширээ' : 'Table')}
          {slider('tiles', mn ? 'Мод' : 'Tiles')}
          <div className="daaluu-size-footer">
            <span>{isAuto ? (mn ? 'Дэлгэцэнд тааруулсан' : 'Fitted to your screen') : ''}</span>
            <button type="button" className="daaluu-size-reset" onClick={reset} disabled={isAuto}>{mn ? 'Автомат' : 'Auto'}</button>
          </div>
        </div>
      )}
    </div>
  );
}
